import { ReactNode } from 'react';

import { SxProps, Typography, Stack, tokens } from '@cast/design-system';

import { WizardBottomBar } from './WizardBottomBar';
import { WizardTopBar } from './WizardTopBar';

type WizardScreenLayoutProps = {
  title?: string;
  description?: string;
  children: ReactNode;
  maxWidth?: number;
  contentSx?: SxProps;
  nextButtonLabel?: string;
  hideBottom?: boolean;
};

export const WizardScreenLayout = ({
  title,
  description,
  children,
  maxWidth = 800,
  contentSx,
  nextButtonLabel = 'Next',
  hideBottom = false,
}: WizardScreenLayoutProps) => {
  return (
    <Stack height="100%">
      <WizardTopBar />
      <Stack
        flex={1}
        alignItems="center"
        sx={{
          pt: 40,
          pb: 32,
          px: 32,
          overflowY: 'auto',
          bgcolor: tokens.theme.bg.structural.page,
          ...contentSx,
        }}
      >
        <Stack gap={24} sx={{ width: '100%', maxWidth }}>
          <Stack>
            {title && (
              <Typography
                variant="h5"
                sx={{ color: tokens.theme.fg.structural.primary }}
              >
                {title}
              </Typography>
            )}
            {description && (
              <Typography
                variant="P12R"
                sx={{ color: tokens.theme.fg.structural.secondary }}
              >
                {description}
              </Typography>
            )}
          </Stack>
          {children}
        </Stack>
      </Stack>
      {!hideBottom && <WizardBottomBar nextButtonLabel={nextButtonLabel} />}
    </Stack>
  );
};
